import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Alert, Button, Label, Typography } from 'shared/ui'
import { DefaultModalActions } from 'shared/ui/Modal/ui/DefaultModal/DefaultModalActions'
import { InputNumeric, TextField } from 'shared/ui/TextField'
import { PriceInfo } from 'entities/Billing'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { RemoveSeats } from 'entities/Seat/ui/RemoveSeats/store/RemoveSeats'
import styles from './styles.module.scss'
import { type ManageSeatsStore } from '../store/ManageSeatsStore'

const MAX_TOTAL_VALUE = 9999

export const ManageSeatsUi = observer(({ store }: { store: ManageSeatsStore }) => {
  const {
    modalId,
    onCancel,
    seats,
    setSeats,
    init,
    priceInfoStore,
    onBuy,
    requestBuySeatsInfoStatus,
    entities,
    disabled,
  } = store

  const { subscriptionStore } = useEntitiesContext()
  const { seatsAvailable } = subscriptionStore

  const isAllowed = ({ floatValue }: { floatValue?: number }) => {
    return !floatValue || floatValue <= MAX_TOTAL_VALUE
  }

  const onBlur = () => {
    if (!seats) {
      setSeats('1')
    }
  }
  const priceInfoUiData = priceInfoStore.priceInfoUiData

  useEffect(init, [])

  return (
    <>
      {requestBuySeatsInfoStatus.status.error && (
        <Alert
          marginInline={24}
          marginBottom={24}
          item={{
            type: 'alert',
            desc: requestBuySeatsInfoStatus.status.error,
          }}
        />
      )}
      <Alert
        marginInline={24}
        marginBottom={24}
        item={{
          type: 'infoBlue',
          desc: (
            <>
              Your workspace has{' '}
              <Typography ariaLabel={'count'} variant={'body-md-semibold'}>
                {seatsAvailable} empty seat{seatsAvailable !== 1 ? 's' : ''}
              </Typography>{' '}
              available
            </>
          ),
        }}
        rightActions={
          seatsAvailable
            ? [
                {
                  text: 'Remove',
                  variant: 'button',
                  type: 'primary',
                  onClick: () => {
                    new RemoveSeats(entities, modalId).openModal()
                  },
                },
              ]
            : undefined
        }
      />
      <div className={styles.seatsInput}>
        <Label
          label={{
            text: 'Add seats',
          }}
        />
        <TextField
          Input={InputNumeric}
          variant={'stroke'}
          size={'large'}
          InputProps={{
            isAllowed,
            allowNegative: false,
          }}
          onBlur={onBlur}
          value={seats}
          onChange={setSeats}
        />
      </div>
      {seats && priceInfoUiData && (
        <div className={styles.priceInfo}>
          <PriceInfo priceInfoStore={store.priceInfoStore} labelPrefix='Seats' />
        </div>
      )}

      <DefaultModalActions>
        <Button text={'Cancel'} onClick={onCancel} size={'medium'} contained={'secondary'} />
        <Button
          text={`Buy ${seats || ''} seat${Number(seats) !== 1 ? 's' : ''}`}
          onClick={onBuy}
          loading={requestBuySeatsInfoStatus.status.isLoading}
          size={'medium'}
          contained={'primary'}
          disabled={disabled}
        />
      </DefaultModalActions>
    </>
  )
})
